import React from 'react'

import cn from 'classnames'

export const HeaderMenu = ({ currentUrl }) => {
  return (
    <div className="flex ml-[38px] h-[45px] border-l border-[rgb(62,67,73,0.40)] pl-[38px] items-center space-x-6">
      <MenuItem url="/" label="Репрайсер" currentUrl={currentUrl} />
      <MenuItem url="/parsing" label="Парсинг" currentUrl={currentUrl} />
      <MenuItem url="/video" label="Видеообзоры" currentUrl={currentUrl} />
    </div>
  )
}

const MenuItem = ({ url, label, currentUrl }) => {
  return (
    <div className="h-[45px] flex relative items-center">
      <a
        href={url}
        className={cn(
          'block text-[#454A50] text-lg leading-[22px] font-semibold cursor-pointer hover:text-white transition-all',
          {
            "!text-white after:content-[''] after:bg-white after:h-0.5 after:absolute after:bottom-0 after:left-[18px] after:right-[18px]":
              currentUrl === url
          }
        )}
      >
        {label}
      </a>
    </div>
  )
}
